import { VxeSwitch } from 'vxe-pc-ui';
import defPropMixin from './defPropMixin';
export default {
  name: 'XSwitch',
  components: {
    VxeSwitch
  },
  mixins: [defPropMixin],
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Boolean],
      default: false
    },
    openLabel: {
      type: String,
      default: ''
    },
    closeLabel: {
      type: String,
      default: ''
    },
    openValue: {
      type: [String, Number, Boolean],
      default: true
    },
    closeValue: {
      type: [String, Number, Boolean],
      default: false
    },
    openIcon: {
      type: String,
      default: ''
    },
    closeIcon: {
      type: String,
      default: ''
    },
    openActiveIcon: {
      type: String,
      default: ''
    },
    closeActiveIcon: {
      type: String,
      default: ''
    }
  },
  emits: ['update:value', 'change'],
  setup(props, context) {
    const handleChanged = ({
      value,
      $event
    }) => {
      context.emit('change', {
        value,
        $event
      });
      context.emit('update:value', value, $event);
    };
    return {
      handleChanged
    };
  }
};